import { Injectable, inject } from '@angular/core';
import { ProcessingRuntimeRenderService } from '../../../Drive/services/processing-runtime-render.service';
import { RenderSessionStore } from '../../shared/state/render-session.store';

export type ProcessingRenderFlowRequest = Parameters<ProcessingRuntimeRenderService['render']>[0];

@Injectable({ providedIn: 'root' })
export class ProcessingRenderFlowService {
  private readonly renderer = inject(ProcessingRuntimeRenderService);
  private readonly sessionStore = inject(RenderSessionStore);

  async render(request: ProcessingRenderFlowRequest): Promise<void> {
    this.sessionStore.start({
      flow: 'processing',
      category: 'non-editor',
      surface: 'processing-video',
      jobId: request.clientRender.jobId || request.fallbackJobId,
      pipeline: 'Processing'
    });

    try {
      await this.renderer.render(request);
      this.sessionStore.complete();
    } catch (err) {
      this.sessionStore.fail(this.errorMessage(err));
      throw err;
    }
  }

  private errorMessage(err: unknown): string {
    return err instanceof Error ? err.message : 'Processing render failed.';
  }
}
